import { RemoteCourseCreate } from 'data/usecases';
import { makeApiUrlCourse } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCourseCreate = (): RemoteCourseCreate => {
  return new RemoteCourseCreate(makeApiUrlCourse(), makeAxiosHttpClient());
};
